<template>
  <section class="companies">
    <div class="float-left" v-if="simplify">
      <small
        v-if="sincronized == dataUsers.length"
        class="
          rounded-circle
          icon-checkmark
          bg-white
          border-secondary border
          text-white
        "
      ></small>
      <small
        v-else
        class="
          rounded-circle
          icon-checkmark
          bg-white
          border-secondary border
          text-white
        "
      ></small>
    </div>
    <div class="ml-4 mt-1" v-if="simplify">
      <h6>{{ $t("lang.preparingapp.defineyourteam") }}</h6>
      <small class="text-secondary">{{
        $t("lang.preparingapp.defineyourteam_desc")
      }}</small>
      <span class="my-4 border-top w-100"></span>
      <li v-for="(row, key) in dataUsers">
        <small
          v-if="row.nylas_email_sync_status == 0"
          class="
            mr-1
            rounded-circle
            icon-checkmark
            bg-white
            border-secondary border
            text-white
          "
        ></small>
        <small v-if="row.nylas_email_sync_status == 1">
          <small
            class="p-1 rounded-circle icon-checkmark bg-primary text-white"
          ></small
        ></small>
        <small> {{ row.email }}</small>
        <button
          v-if="currentUser.email == row.email"
          @click="$router.push('/settings-account?synchronisation=1')"
          class="ml-2 p-0 px-1 btn btn-sm btn-primary"
        >
          <small
            >{{ $t("lang.preparingapp.defineyourteam_btn") }}
            <i class="icon-calendar"></i
          ></small>
        </button>
      </li>
    </div>
    <div class="float-left" v-if="listProfileComplete">
      <small v-if="currentUser.avatar">
        <small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small>
      </small>
      <small v-else>
        <small class="rounded-circle icon-checkmark bg-white border-secondary border text-white"></small>
      </small>
    </div>
    <div class="ml-4 mt-1" v-if="listProfileComplete">
      <h6 class="mr-4">{{ $t("lang.preparingapp.complete_profile") }}</h6>
      <button
        v-if="isBillingSaleOrSales"
        @click="gotProfile()"
        :class="proComplete ? 'float-right btn-primary btn btn-sm ' : 'ml-1 float-right btn-outline-primary btn btn-sm '">
        {{ $t("lang.preparingapp.complete_profile") }}
      </button>
      <small class="text-secondary">
        {{ $t("lang.preparingapp.define_complete_profile") }}
      </small>
    </div>
    <ol class="breadcrumb" v-if="currentUser.role_id != 1 && !simplify && !listProfileComplete">
      <li class="breadcrumb-item active">{{ $t("lang.label.clientteam") }}</li>
    </ol>

    <main class="contenedor" v-if="!simplify && !listProfileComplete">
      <LoadingSpinner v-if="loading" />
      <div class="row" v-if="!loading">
        <div class="col-sm-12">
          <div class="card mt-3 p-4">
            <section class="">
              <div class="row float-right">
                <div v-if="!hasDeclinedPayments">
                  <button
                    class="ml-3 float-right btn btn-primary"
                    @click="addSales"
                    type="submit"
                    v-if="currentUser.role_id == 4"
                  >
                    <i class="icon-plus1"></i> {{ $t("lang.user.new") }}
                  </button>
                  <button
                    class="float-right btn btn-primary"
                    @click="addUserTeam"
                    v-if="
                      currentUser.role_id == 2 && currentUser.is_agency == 0
                    "
                    type="submit"
                  >
                    <i class="icon-plus1"></i> {{ $t("lang.user.new") }}
                  </button>
                </div>
              </div>
            </section>
            <div class="mt-3">
              <LoadingSpinner v-if="loadingteam" />
              <table class="table table-striped" v-if="!loadingteam">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">{{ $t("lang.column.name") }}</th>
                    <th scope="col">{{ $t("lang.column.email") }}</th>
                    <th scope="col" v-if="currentUser.is_agency == 1">
                      {{ $t("lang.label.calendarsettings") }}
                    </th>
                    <th scope="col" v-if="currentUser.is_agency == 1">
                      {{ $t("lang.label.orders") }}
                    </th>
                    <th scope="col">{{ $t("lang.column.status") }}</th>
                  </tr>
                </thead>
                <tbody v-if="dataUsers">
                  <tr v-for="(row, key) in dataUsers" :key="key">
                    <td>
                      <div>{{ row.username }}</div>
                      <span class="badge btn-primary">
                        {{ row.role_name }}
                      </span>
                    </td>
                    <td>
                      {{ row.email }}
                    </td>

                    <td v-if="currentUser.is_agency == 1">
                      <div v-if="row.nylas_email_sync">
                        <span class="mr-2">
                          <i
                            title="workspace"
                            v-if="row.nylas_email_sync_status > '0'"
                            class="icon-circle text-success"
                          >
                          </i>
                          <i
                            v-else
                            class="icon-circle text-danger"
                            title="workspace"
                          >
                          </i>
                          {{ row.nylas_email_sync }}</span
                        >
                      </div>
                      <div v-else>-</div>
                    </td>
                    <td v-if="currentUser.is_agency == 1">
                      <div v-if="row.targets">
                        <div
                          v-for="(target, key) in row.targets.split(',')"
                          :key="key"
                        >
                          <span
                            class="badge"
                            :class="getBadgeTargetStatus(target.split('/')[1])"
                          >
                            {{ target.split("/")[0] }}
                          </span>
                        </div>
                      </div>
                      <div v-else>-</div>
                    </td>

                    <td v-if="currentUser.is_agency == 1">
                      <div v-if="row.user_status_id == 3">
                        <span class="badge btn-danger">
                          {{ $t("lang.label.deleted") }}
                        </span>
                      </div>

                      <div
                        v-else-if="
                          row.warmup_activated > 0 &&
                          warmupDays(row.warmup_date) < 15
                        "
                      >
                      <Tooltip :text="$t('lang.general.teamwarmingup')" :width="''">
                        <span class="badge btn-warning cursor-pointer">
                          Warming-up
                        </span>
                      </Tooltip>
                        <div class="small">
                          {{ warmupDays(row.warmup_date) }}
                          {{ $t("lang.label.days") }}
                        </div>
                      </div>
                      <div
                        v-else-if="
                          row.warmup_activated > 0 &&
                          warmupDays(row.warmup_date) >= 15 &&
                          row.targets_active > 0
                        "
                      >
                      <Tooltip :text="$t('lang.general.teamactive')" :width="''">
                        <span class="badge btn-success cursor-pointer">
                          {{ $t("lang.label.active") }}
                        </span>
                      </Tooltip>
                      </div>
                      <div v-else>
                        <Tooltip :text="$t('lang.general.teampending')" :width="''">
                        <span class="badge btn-secondary cursor-pointer">
                          Creation pending
                        </span>
                      </Tooltip>
                      </div>
                    </td>
                    <td v-else>
                      {{ row.user_status_name }}
                      </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="no-results-row">
                    <td colspan="4">
                      <span class="font-weight-bold ft-1-5 text-center"
                        >There are no data</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal :name="'sales'">
        <div class="p-4 text-center">
          <label>
            <h4>{{ $t("lang.user.add") }}</h4>
          </label>
        </div>
        <div class="px-4 pb-4 text-center">
          <AddTeamMember :add="true" @newForm="addMemberSales($event)" />
        </div>
      </Modal>

      <modal
        name="emails"
        :clickToClose="true"
        class="modal-preview p-4"
        :resizable="true"
        height="auto"
        width="70%"
        :scrollable="true"
        :max-width="800"
        :ref="modalkey"
      >
        <div class="row px-4 py-2" v-if="emails">
          <div v-for="email in emails" class="col-12 py-2 card my-2">
            <small>
              <i class="icon-checkmark text-success" v-if="email.link_id"></i>
              {{ email.from[0].email }}</small
            >
            <small>{{ getEmailDate(email.date) }}</small>
            <Fieldset :title="email.subject" :mykey="email.id" :open="false">
              {{ email.snippet }}
            </Fieldset>
          </div>
        </div>
        <LoadingSpinner v-else />
      </modal>

      <modal
        name="example"
        :clickToClose="false"
        :resizable="true"
        height="auto"
        width="80%"
      >
        <div class="p-4">
          <label>
            <h4>{{ $t("lang.user.add") }}</h4>
          </label>
          <div>
            <form v-on:submit.prevent class="px-4 py-3">
              <vue-form-generator
                ref="teamUserForm"
                :schema="schema"
                :model="this.dataUser"
                :options="formOptions"
              ></vue-form-generator>
            </form>
            <div class="mt-4" v-if="alert.message">
              <AlertError :msgError="alert.message" />
            </div>
          </div>
        </div>
        <div class="px-4 pb-4 text-center">
          <button
            class="
              btn
              large
              cursor-pointer
              font-weight-bolder
              btn-sm btn-success
              mx-1
              px-4
            "
            :disabled="request == true"
            @click="addNewUser"
          >
            {{ $t("lang.button.send") }}
          </button>

          <button
            class="
              btn
              large
              cursor-pointer
              font-weight-bolder
              btn-sm btn-outline-dark
              mx-1
              px-4
            "
            @click="cerrar"
          >
            {{ $t("lang.button.back") }}
          </button>
        </div>
      </modal>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { statusPointMixin } from "@/_mixins/";
import { clientsService, usersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import AlertError from "@/components/AlertError.vue";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import Tutorial from "@/components/Tutorial.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import moment from "moment";
import AddTeamMember from "@/components/Onboarding/AddTeamMember.vue";
import Modal from "@/components/Common/Modal.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  props: {
    userId: {
      type: String,
      default: "0",
    },
    simplify: {
      type: Boolean,
      default: false,
    },
    listProfileComplete: {
      type: Boolean,
      default: false,
    },
    isBillingSaleOrSales: {
      type: Boolean,
      default: false,
    },
    isSales: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      sincronized: 0,
      emails: false,
      result_invitation: "",
      dataUsers: [],
      request: false,
      loadingteam: false,
      modalkey: 212112,
      dataUser: {},
      schema: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          {
            type: "input",
            inputType: "hidden",
            model: "team_user_id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "email",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 255,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "emailValidator",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.title"),
            model: "title",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.firstname"),
            model: "name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.lastname"),
            model: "lastname",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "password",
            label: this.$t("lang.label.password"),
            model: "password",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "validatePassword",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "password",
            label: this.$t("lang.label.confirmpassword"),
            model: "confirm_password",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "confirmPasswordValidator",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: this.$t("lang.label.role"),
            model: "role_id",
            readonly: false,
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
            selectOptions: {},
            values: function () {
              return [
                { id: "2", name: "Admin" },
                { id: "3", name: "Non-admin" },
                { id: "4", name: "Billing" },
              ];
            },
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
            styleClasses: "col-md-12",
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },

  mixins: [statusPointMixin],

  components: {
    LoadingSpinner,
    "vue-form-generator": VueFormGenerator.component,
    AlertError,
    Tutorial,
    Fieldset,
    AddTeamMember,
    Modal,
    Tooltip
  },

  watch: {},

  computed: {
    ...mapState({
      loading: (state) => state.companies.loading,
      alert: (state) => state.alert,
      currentUser: (state) => state.authentication.user,
      plans: (state) => state.plans.all,
      hasDeclinedPayments: (state) =>
        state.authentication.toastNotificationData.hasDeclinedPayments.length >
        0,
    }),
    proComplete(){
			const jobTitle = this.currentUser.title
			const avatar = this.currentUser.avatar
			return (jobTitle && avatar) ? true : false
		}
  },
  created() {
    this.getData();
  },

  methods: {
    ...mapActions("onboarding", {
      goToSettingAccount: "goToSettingAccount"
    }),
    ...mapActions("users", {
      getAllUserTeam: "getAllUserTeam",
    }),

    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    connect(user) {
      usersService
        .getAuthenticationUrl(
          user.nylas_email_sync,
          user.name,
          user.lastname,
          user.id
        )
        .then(
          (result) => {
            window.open(result, "_blank");
          },
          (error) => {
            this.$store.dispatch("alert/error", error, { root: true });
          }
        );
    },
    getEmailDate(emaildate) {
      var momentObj = moment(emaildate * 1000);
      var momentString = momentObj.format("YYYY-MM-DD H:m:s");
      return momentString;
    },
    openEmails(user_id, limit, page) {
      this.emails = false;
      this.$modal.show("emails");
      this.modalkey++;
      clientsService.getNylasEmails(user_id, limit, page).then((result) => {
        this.emails = result;
      });
    },
    closeModal() {
      this.emails = false;
      this.$modal.hide("emails");
    },
    getData() {
      this.loadingteam = true;
      if (this.currentUser.is_agency == 1) {
        usersService.getGroupList().then((result) => {
          this.dataUsers = result;
          this.dataUsers.forEach((res) => {
            if (res.nylas_email_sync_status == 1) {
              this.sincronized++;
            }
            //profileComplete  show if the user has data in the avatar, title property
            if(res.title && res.avatar){
              res.profileComplete = true
            } else {
              res.profileComplete = false
            }
          });
          this.loadingteam = false;
        });
      } else {
        usersService.getAll().then((result) => {
          this.dataUsers = result;
          this.dataUsers.forEach((res) => {
            if (res.nylas_email_sync_status == 1) {
              this.sincronized++;
            }
          });
          this.loadingteam = false;
        });
      }
    },
    addUserTeam() {
      this.$store.dispatch("alert/clear");
      this.dataUser = { team_user_id: this.userId };
      this.$modal.show("example");
    },

    addSales() {
      this.$modal.show("sales");
    },
    addMemberSales(member) {
      usersService.addSalesRep(member).then((resp) => {
        if (resp) {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 1500,
          });
          this.$modal.hide("sales");
          this.getData();
        }
      });
    },

    cerrar() {
      this.$modal.hide("example");
      this.request = false;
    },

    addNewUser() {
      this.$refs.teamUserForm.validate();
      if (this.$refs.teamUserForm.errors.length > 0) {
        return;
      }

      const price = this.currentUser.plan_price;
      const price1 = (
        this.currentUser.plan_price * this.currentUser.recurring_payment_period
      ).toFixed(2);

      let price2;

      const rightNow = new Date();

      const nextPaymentDate = new Date(this.currentUser.next_payment_date); //2021-11-17 15:25:09

      let timeLeft = nextPaymentDate.getTime() - rightNow.getTime();

      timeLeft = Math.round(timeLeft / (1000 * 60 * 60 * 24));

      if (this.currentUser.recurring_payment_period == 12) {
        timeLeft = Math.ceil(timeLeft / 30);
        price2 = (price * timeLeft).toFixed(2);
      } else {
        price2 = ((price / 30) * timeLeft).toFixed(2);
      }

      this.cerrar();
      this.$swal({
        type: "warning",
        title: this.$t("lang.user.messagepayment"),
        html: this.$t("lang.user.messagepaymentinfo", {
          price: price1 + " €",
          price2: price2 + " €",
        }),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.request = true;
          const { dataUser } = this;
          const { dispatch } = this.$store;
          dispatch("authentication/addNewUser", { dataUser }).then(
            (reponse) => {
              this.getData();
              this.cerrar();
              this.request = false;
              this.$swal.fire("", this.$t("lang.user.usercreated"), "success");
            },
            (error) => {
              this.request = false;
              this.$swal.fire("", this.$t("lang.user.usernotcreated"), "error");
            }
          );
        }
      });
    },

    showWarning(role_id) {
      return role_id == 2;
    },

    warmupDays(date) {
      var date1 = new Date(date);
      var date2 = new Date();

      // To calculate the time difference of two dates
      var days = parseInt(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );
      return days;
    },
    gotProfile() {
			this.goToSettingAccount(true);
			this.$router.push({ name: 'settings-account'})
    },
    getBadgeTargetStatus(status) {
      switch (status) {
        case "1":
          return "btn-success";
          break;
        case "2":
          return "btn-danger";
          break;
        case "3":
          return "btn-warning";
          break;
        case "4":
          return "btn-success";
          break;
        case "5":
          return "btn-secondary";
          break;
      }
    },
  },
};
</script>

<style scoped>
.datepicker {
  transform: translate(0, 3.1em);
}
</style>
